import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { useDrawerContext } from '../shared/contexts';
import {
  ListagemDeUsuarios,
  DetalheDeUsuarios,
  PaginaInicial,
} from '../pages';
import { ListagemDeParceiros } from '../pages/parceiros/ListagemDeParceiros';
import { DetalheDeParceiros } from '../pages/parceiros/DetalheDeParceiros';
import { ListagemDeTickets } from '../pages/tickets/ListagemDeTickets';
import { ListagemMeusLeads } from '../pages/leads/ListagemMeusLeads';
import { DetalheDeTickets } from '../pages/tickets/DetalheDeTickets';
import { ListagemDeLeads } from '../pages/leads/ListagemDeLeads';
import { EstrategiaVendas } from '../pages/sobre-projeto/SobreProjeto';

export const AppRoutes = () => {
  const { setDrawerOptions } = useDrawerContext();

  useEffect(() => {
    setDrawerOptions([
      {
        icon: 'group',
        path: '/usuarios',
        label: 'Usuários',
      },
      {
        icon: 'handshake',
        path: '/parceiros',
        label: 'Parceiros',
      },
      {
        icon: 'confirmation_number',
        path: '/tickets',
        label: 'Tickets',
      },
      {
        icon: 'group',
        path: '/leads',
        label: 'Leads',
      },
      {
        icon: 'group',
        path: '/my-leads',
        label: 'Meus Leads',
      },
    ]);
  }, [setDrawerOptions]);

  return (
    <Routes>
      <Route path="/Leads" element={<ListagemDeLeads />} />
      <Route path="/instrucao" element={<EstrategiaVendas />} />
      <Route path="/my-leads" element={<ListagemMeusLeads/>} />
      <Route path="/tickets" element={<ListagemDeTickets />} />
      <Route path="/tickets/detalhe/:id" element={<DetalheDeTickets />} />
      <Route path="/usuarios" element={<ListagemDeUsuarios />} />
      <Route path="/usuarios/detalhe/:id" element={<DetalheDeUsuarios />} />
      <Route path="/parceiros" element={<ListagemDeParceiros />} />
      <Route path="/parceiros/detalhe/:id" element={<DetalheDeParceiros />} />
      <Route path="*" element={<PaginaInicial />} />
    </Routes>
  );
};
